export default __webpack_public_path__ + "static/step2-1c1f415561bea76e5e1441c898f46a9c.svg";